"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResultSeverity = exports.getAUDSeverityDescriptor = exports.SeverityLimits = exports.SeverityDescriptor = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _roles = require("./roles.utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Limits are inclusive
var SeverityLimits = {
  No: 1,
  Mild: 3,
  Moderate: 5,
  Severe: 11
};
exports.SeverityLimits = SeverityLimits;
var SeverityDescriptor = {
  No: 'no',
  Mild: 'mild',
  Moderate: 'moderate',
  Severe: 'severe'
};
exports.SeverityDescriptor = SeverityDescriptor;
var getAUDSeverityDescriptor = function getAUDSeverityDescriptor(score) {
  if (score <= SeverityLimits.No) {
    return SeverityDescriptor.No;
  }
  if (score <= SeverityLimits.Mild) {
    return SeverityDescriptor.Mild;
  }
  if (score <= SeverityLimits.Moderate) {
    return SeverityDescriptor.Moderate;
  }
  return SeverityDescriptor.Severe;
};
exports.getAUDSeverityDescriptor = getAUDSeverityDescriptor;
var CommonParagraphUnderCard = function CommonParagraphUnderCard() {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", {
    className: "mb-[20px]"
  }, "When navigating severe AUD, changing your drinking habits can feel overwhelming. However, with the proper support, you can make a meaningful change."), /*#__PURE__*/_react.default.createElement("p", null, "Research shows that", ' ', /*#__PURE__*/_react.default.createElement("span", {
    className: "tw-body-sm-medium text-green1-55"
  }, "holistic treatment, including medication, therapy, and peer support"), ' ', "is most effective in reducing alcohol consumption."));
};
var commonDisclaimer = 'Results based on anonymized data from Monument patients and on file at Monument.';
var requirementDisclaimer = 'Patients required to follow suggested treatment regime to achieve claimed results.';
var GoodNewsParagraph = function GoodNewsParagraph() {
  return /*#__PURE__*/_react.default.createElement("p", {
    className: "mb-0"
  }, "The good news? On average, Monument members saw a", ' ', /*#__PURE__*/_react.default.createElement("span", {
    className: "tw-body-regular"
  }, "51% decrease in heavy drinking days per week by their 4th appointment."));
};
var MembersSegmentParagraph = function MembersSegmentParagraph(_ref) {
  var percentage = _ref.percentage,
    _ref$showShareStruggl = _ref.showShareStruggles,
    showShareStruggles = _ref$showShareStruggl === void 0 ? false : _ref$showShareStruggl,
    _ref$showYouAreNotAlo = _ref.showYouAreNotAlone,
    showYouAreNotAlone = _ref$showYouAreNotAlo === void 0 ? false : _ref$showYouAreNotAlo;
  return /*#__PURE__*/_react.default.createElement("p", {
    className: "mb-[15px]"
  }, showYouAreNotAlone && /*#__PURE__*/_react.default.createElement("span", {
    className: "tw-body-regular"
  }, "You are not alone."), ' ', "Approximately ", /*#__PURE__*/_react.default.createElement("span", {
    className: "tw-body-regular"
  }, percentage, "%"), " of Monument members had similar results. ", showShareStruggles && 'Many more share your struggles.');
};
var Severity = {
  Default: {
    getParagraphUnderCard: function getParagraphUnderCard(level) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Like other health conditions, alcohol use disorder can be effectively treated with the right care. Treating ", level, " AUD can improve your mental, physical, and social well-being and help avoid more severe alcohol-related consequences.");
    },
    getRecommendParagraph: function getRecommendParagraph(level) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Because you\u2019re showing signs of alcohol use disorder, we recommend that you sign up for a personalized plan that includes ", (0, _roles.getRoleNameLower)(_roles.UserRoles.Doctor), " care and one-on-one therapy.");
    }
  },
  No: {
    level: SeverityDescriptor.No,
    paragraphUnderCard: /*#__PURE__*/_react.default.createElement(CommonParagraphUnderCard, null),
    recommendedParagraph: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(MembersSegmentParagraph, {
      percentage: 5
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "mb-0"
    }, "Even if you\u2019re not showing signs of AUD, it\u2019s possible alcohol is holding you back. Preventative treatment can help you build healthier habits and prevent potential alcohol-related consequences.")),
    disclaimer: commonDisclaimer
  },
  Mild: {
    level: SeverityDescriptor.Mild,
    paragraphUnderCard: /*#__PURE__*/_react.default.createElement(CommonParagraphUnderCard, null),
    recommendedParagraph: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(MembersSegmentParagraph, {
      percentage: 10,
      showShareStruggles: true,
      showYouAreNotAlone: true
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "mb-0"
    }, "Like other health conditions, alcohol use disorder can be effectively treated with the right care. Treating mild AUD can improve your mental, physical, and social well-being, and help avoid more severe alcohol-related consequences.")),
    disclaimer: commonDisclaimer
  },
  Moderate: {
    level: SeverityDescriptor.Moderate,
    paragraphUnderCard: /*#__PURE__*/_react.default.createElement(CommonParagraphUnderCard, null),
    recommendedParagraph: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(MembersSegmentParagraph, {
      percentage: 20,
      showShareStruggles: true,
      showYouAreNotAlone: true
    }), /*#__PURE__*/_react.default.createElement(GoodNewsParagraph, null)),
    disclaimer: "".concat(commonDisclaimer, " ").concat(requirementDisclaimer)
  },
  Severe: {
    level: SeverityDescriptor.Severe,
    paragraphUnderCard: /*#__PURE__*/_react.default.createElement(CommonParagraphUnderCard, null),
    recommendedParagraph: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(MembersSegmentParagraph, {
      percentage: 65,
      showYouAreNotAlone: true
    }), /*#__PURE__*/_react.default.createElement(GoodNewsParagraph, null)),
    disclaimer: "".concat(commonDisclaimer, " ").concat(requirementDisclaimer)
  }
};
var getResultSeverity = function getResultSeverity(score) {
  var severity = Severity.Severe;
  if (score <= SeverityLimits.No) {
    severity = Severity.No;
  } else if (score <= SeverityLimits.Mild) {
    severity = Severity.Mild;
  } else if (score <= SeverityLimits.Moderate) {
    severity = Severity.Moderate;
  }
  return (0, _lodash.defaults)(severity, Severity.No);
};
exports.getResultSeverity = getResultSeverity;